import React, { useState } from 'react';
import { Card, Form, Button, Alert, Spinner } from 'react-bootstrap';
import { useAuth } from '../../context/AuthContext';
import { useLanguage } from '../../context/LanguageContext';
import { trySetServiceUnavailableError } from '../../utils/serviceUnavailableMessages';

const ForgotPassword = ({ onSwitchToLogin, onResetSent }) => {
  const { requestPasswordReset } = useAuth();
  const { t } = useLanguage();
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      await requestPasswordReset(email);
      onResetSent(email);
    } catch (err) {
      if (trySetServiceUnavailableError(err, setError, t)) return;
      const errorText = err.data?.errorText;
      if (typeof errorText === 'string') {
        setError(errorText);
      } else if (typeof errorText === 'object') {
        const messages = Object.values(errorText).flat();
        setError(messages.join(' '));
      } else {
        setError(t('forgotPassword.failed'));
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card className="auth-card" style={{ maxWidth: '420px', width: '100%' }}>
      <Card.Body className="p-4 p-md-5">
        <div className="text-center mb-4">
          <div className="icon-circle bg-warning bg-gradient mx-auto mb-3">
            <i className="bi bi-lock text-white"></i>
          </div>
          <h2 className="fw-bold">{t('forgotPassword.title')}</h2>
          <p className="text-muted">{t('forgotPassword.subtitle')}</p>
        </div>

        {error && <Alert variant="danger">{error}</Alert>}

        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-4">
            <Form.Label>{t('forgotPassword.emailLabel')}</Form.Label>
            <Form.Control
              type="email"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                setError('');
              }}
              placeholder={t('forgotPassword.emailPlaceholder')}
              required
              autoComplete="email"
              size="lg"
            />
          </Form.Group>

          <Button
            type="submit"
            className="btn-gradient w-100 py-2"
            size="lg"
            disabled={loading}
          >
            {loading ? (
              <>
                <Spinner animation="border" size="sm" className="me-2" />
                {t('forgotPassword.sending')}
              </>
            ) : (
              t('forgotPassword.sendResetLink')
            )}
          </Button>
        </Form>

        <hr className="my-4" />

        <div className="text-center">
          <Button variant="link" className="p-0 link-primary" onClick={onSwitchToLogin}>
            <i className="bi bi-arrow-left me-2"></i>
            {t('forgotPassword.backToLogin')}
          </Button>
        </div>
      </Card.Body>
    </Card>
  );
};

export default ForgotPassword;
